let curriculum = {};

export const setCurriculum = (newVersion) => {
  curriculum = newVersion;
};

export const getCurriculum = () => curriculum;
